import {
  createProduct,
  deleteProduct,
  getProductVariants,
  listProducts,
  listProductsNext,
  updateProduct,
} from '../thunks/marketplace-products';
import { handlePending, handleRejected } from './utils';

export const marketplaceProductsReducers = (builder) => {
  // list products
  builder
    .addCase(listProducts.fulfilled, (state, action) => {
      const products = action.payload?.data || [];
      const offset = action.payload?.offset || 0;
      state.products.value = products;
      state.products.offset = offset;
      state.products.hasMore = products.length > 0;
      state.products.loading = false;
      state.products.initialised = true;
    })
    .addCase(listProducts.pending, (state) => {
      if (!state.products.initialised) {
        state.products.loading = true;
      }
    })
    .addCase(listProducts.rejected, (state) => handleRejected(state, 'products'));

  builder
    .addCase(listProductsNext.fulfilled, (state, action) => {
      const products = action.payload?.data || [];
      const offset = action.payload?.offset || 0;
      state.products.value = [...state.products.value, ...products];
      state.products.offset = offset;
      state.products.hasMore = products.length > 0;
      state.products.loading = false;
      state.products.initialised = true;
    })
    .addCase(listProductsNext.pending, (state) => {
      if (!state.products.initialised) {
        state.products.loading = true;
      }
    })
    .addCase(listProductsNext.rejected, (state) => handleRejected(state, 'products'));

  // create product
  builder
    .addCase(createProduct.fulfilled, (state) => {
      // const products = [...state.products.value];
      // const product = action.payload;
      // products.push(product);
      // state.products.value = products;
      state.newProductForm.loading = false;
    })
    .addCase(createProduct.pending, (state) => handlePending(state, 'newProductForm'))
    .addCase(createProduct.rejected, (state) => handleRejected(state, 'newProductForm'));

  // update product
  builder
    .addCase(updateProduct.fulfilled, (state, action) => {
      const products = [...state.products.value];
      const updatedProduct = action.payload;
      const productIndex = products.findIndex((product) => product.id === updatedProduct.id);
      if (productIndex >= 0) {
        products[productIndex] = { ...products[productIndex], ...updatedProduct };
      }
      state.products.value = products;
      state.newProductForm.loading = false;
    })
    .addCase(updateProduct.pending, (state) => handlePending(state, 'newProductForm'))
    .addCase(updateProduct.rejected, (state) => handleRejected(state, 'newProductForm'));

  // delete product
  builder.addCase(deleteProduct.fulfilled, (state, action) => {
    const products = [...state.products.value];
    const productId = action.payload;
    const productIndex = products.findIndex((product) => product.id === productId);
    if (productIndex >= 0) {
      products.splice(productIndex, 1);
    }
    state.products.value = products;
  });

  // get product variants
  builder
    .addCase(getProductVariants.fulfilled, (state, action) => {
      state.selectedProductVariant = action.payload || [];
    })
    .addCase(getProductVariants.pending, (state) => {
      state.selectedProductVariant = [];
    })
    .addCase(getProductVariants.rejected, (state) => {
      state.selectedProductVariant = [];
    });
};
